module.exports = __webpack_public_path__ + "img/7d.2769d98c.png";